import React from "react";
import {
  Svg,
  Line,
  Polyline,
  Polygon,
  Path,
  Rect,
  Circle,
  Ellipse,
  Text,
  Tspan,
  G,
  Stop,
  ClipPath,
  LinearGradient,
  RadialGradient,
} from "@react-pdf/renderer";

export const Pourcentage = ({color} : {color: string}) => {
  // @ts-ignore
  return (<Svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 43.58 55.35">
  <G fill={color}>
    <Path d="M0,8.73C0,5.92.7,3.77,2.11,2.26,3.51.75,5.56,0,8.26,0s4.76.75,6.16,2.26c1.4,1.51,2.1,3.66,2.1,6.47v17.93c0,2.81-.7,4.96-2.1,6.47-1.4,1.51-3.46,2.26-6.16,2.26s-4.76-.75-6.16-2.26c-1.4-1.51-2.11-3.66-2.11-6.47V8.73ZM5.46,27.05c0,2.29.94,3.43,2.81,3.43.88,0,1.57-.27,2.07-.82.49-.54.74-1.42.74-2.61V8.34c0-1.19-.25-2.07-.74-2.61s-1.18-.82-2.07-.82c-1.87,0-2.81,1.14-2.81,3.43v18.71ZM29.78.39h5.07L13.33,54.96h-5.07L29.78.39ZM27.05,28.69c0-2.81.7-4.96,2.1-6.47,1.4-1.51,3.46-2.26,6.16-2.26s4.75.75,6.16,2.26c1.4,1.51,2.11,3.66,2.11,6.47v17.93c0,2.81-.7,4.96-2.11,6.47-1.4,1.51-3.46,2.26-6.16,2.26s-4.76-.75-6.16-2.26c-1.4-1.51-2.1-3.66-2.1-6.47v-17.93ZM32.51,47.01c0,2.29.94,3.43,2.81,3.43.88,0,1.57-.27,2.06-.82s.74-1.42.74-2.61v-18.71c0-1.19-.25-2.07-.74-2.61s-1.18-.82-2.06-.82c-1.87,0-2.81,1.14-2.81,3.43v18.71Z"/>
  </G>
</Svg>
);
};

export default Pourcentage;
